import {
  httpRequest as sharedHttpRequest,
  type HttpRequestConfig,
} from '@utils/httpClient';

// Re-export all types
export type {
  HttpMethod,
  HttpRequestData,
  HttpRequestParams,
  ApiBaseType,
  HttpRequestConfig,
  ErrorResponse,
  CustomAxiosError,
} from '@utils/httpClient';

// Wrapper function that provides environment-specific URLs
export const httpRequest = <T>(config: HttpRequestConfig): Promise<T> => {
  return sharedHttpRequest<T>({
    ...config,
    baseUrls: {
      JAVA: import.meta.env.VITE_FACILITY_API_URL,
      INTEGRATION: import.meta.env.VITE_INTEGRATION_URL,
    },
    authType: 'JWT',
  });
};
